import { render, staticRenderFns } from "./panel-block.vue?vue&type=template&id=4fed7cba&scoped=true"
import script from "./panel-block.vue?vue&type=script&lang=js"
export * from "./panel-block.vue?vue&type=script&lang=js"
import style0 from "./panel-block.vue?vue&type=style&index=0&id=4fed7cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fed7cba",
  null
  
)

export default component.exports